import axios from 'axios';

/**
 * Fetch API subscriptions with optional filters.
 *
 * @param {Object} params
 * @return {Promise}
 */
export const fetchApiSubscriptionsAPI = (params = {}) => {
    return axios({
        method: 'get',
        url: '/v2/api-gateway/api-subscriptions',
        params,
    });
};

/**
 * Fetch API List
 *
 * @param {string} name
 * @return {Promise}
 */
export const fetchRestApisListAPI = ({ name } = {}) => {
    return axios({
        method: 'get',
        url: `v2/api-gateway/rest-apis?name=${name}`,
    });
};

/**
 * Fetch Usage Plans List
 *
 * @param {Object} params
 * @return {Promise}
 */
export const fetchUsagePlansListAPI = params => {
    return axios({
        method: 'get',
        url: '/v2/api-gateway/usage-plans',
        params,
    });
};

/**
 * Update Usage Plan for a specific API
 *
 * @param {Object} updatedUsagePlanInfo
 * @return {Promise}
 */
export const updateUsagePlanForApiAPI = ({ updatedUsagePlanInfo }) => {
    return axios({
        method: 'patch',
        url: '/v2/api-gateway/usage-plans/subscribe',
        data: updatedUsagePlanInfo,
    });
};
